module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-test-yourself@3x.f9dae512.png";